/**
 * HowToPlayOverlay
 *
 * The rules panel that sits on top of the game grid.
 * Extracted from App.js lines 1056–1067.
 *
 * Props:
 *   onClose {function} - Called when GOT IT is clicked.
 */

export default function HowToPlayOverlay({ onClose }) {
  return (
    <div style={{
      position: 'absolute', inset: -10,
      backgroundColor: 'rgba(10, 25, 41, 0.98)',
      display: 'flex', flexDirection: 'column',
      justifyContent: 'center', alignItems: 'center',
      borderRadius: '10px', zIndex: 150,
      padding: '20px', border: '3px solid #1f6feb',
    }}>
      <h2 style={{ fontSize: '15px', color: '#1f6feb', marginBottom: '10px' }}>
        HOW TO PLAY
      </h2>

      <div style={{ fontSize: '13px', lineHeight: '1.4', color: '#ccd6f6', textAlign: 'left', margin: '15px 0' }}>
        <p>• FIND THE FISH HIDDEN IN THE <span style={{ color: '#f1c40f' }}>BOTTOM ROW</span>.</p>
        <p>• CLICK TILES TO REVEAL A NUMBER.</p>
        <p>• THE NUMBER REVEALS HOW MANY <span style={{ color: '#ff4d4d' }}>SNAGS</span> ARE IN THE SURROUNDING TILES.</p>
        <p>• AVOID SNAGS OR YOU'LL LOSE A HEART!</p>
      </div>

      <button
        onClick={onClose}
        style={{
          padding: '12px', background: '#238636', color: 'white',
          border: 'none', borderRadius: '4px', cursor: 'pointer',
          fontFamily: 'inherit', fontSize: '13px', width: '50%',
        }}
      >
        GOT IT!
      </button>
    </div>
  );
}